//src/pages/TikpagBICrescimento.jsx

import React from "react";
import TikpagBIVariacaoBase from "./TikpagBIVariacaoBase";

export default function TikpagBICrescimento() {
  return <TikpagBIVariacaoBase tipo="crescimento" />;
}